import React, {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {API, Storage} from "aws-amplify";
import {onError} from "../lib/errorLib";
import merge from "deepmerge";
import LoaderButton from "../components/LoaderButton";
import DeleteIcon from "@mui/icons-material/Delete"
import HqsForm, {initialValues} from "../components/forms/HqsForm";


export default function Hqs() {
    const {hqsId} = useParams();
    const history = useHistory();
    const [hqs, setHqs] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        function loadNote() {
            return API.get("hqs", `/hqs/${hqsId}`, {});
        }

        async function onLoad() {
            try {
                const note = await loadNote();
                const {attachment} = note;

                if (attachment) {
                    note.attachmentURL = await Storage.vault.get(attachment);
                }
                setHqs(note);
            } catch (e) {
                onError(e);
            }
        }
        onLoad();
    }, [hqsId]);

    function saveNote(note) {
        return API.put("hqs", `/hqs/${hqsId}`, {
            body: note
        });
    }

    function deleteNote() {
        return API.del("hqs", `/hqs/${hqsId}`, {});
    }

    async function handleDelete(event) {
        event.preventDefault();
        const confirmed = window.confirm("Are you sure you want to delete this HQS data?");
        if (!confirmed) {
            return;
        }
        setIsDeleting(true);
        try {
            await deleteNote();
            history.push("/");
        } catch (e) {
            onError(e);
            setIsDeleting(false);
        }
    }

    const DeleteButton = () => {
        return (
            <>
                <LoaderButton
                    size={"medium"}
                    variant={"contained"}
                    color={"secondary"}
                    startIcon={<DeleteIcon/>}
                    onClick={handleDelete}
                    isLoading={isDeleting}
                >
                    {"Delete"}
                </LoaderButton>
            </>
        );
    };

/*    const isInt = (value) => {
        return !Number.isNaN(parseInt(value));
    };*/
    /**
     * Get array of entries that Integral keys. All keys for checklist items are Ints, so we use this to filter out
     * values that won't affect the passing or failing of the overall inspection.
     * @param object
     * @returns {[string, unknown][]}
     */
/*    const arrayOfInts = (object) => {
        return Object.entries(object).filter((entry) => (isInt(entry[0])));
    }*/

    /**
     * Assuming all checklist items have keys of the form w.x.y.z...didPass find all "didPass" values and return them in
     * an array.
     * @param value
     * @param parent
     * @returns {({didPass}|*|({didPass}|*|{})[]|{})[]|{}|{didPass}|*}
     */
/*    const getDidPassLeaves = (value, parent) => {
        if (typeof value === "object") {
            if (value.hasOwnProperty("didPass")) {
                return value["didPass"];
            }
            return arrayOfInts(value).map(entry => (getDidPassLeaves(entry[1], !!parent ? parent + "." + entry[0] : entry[0])));
        }
        return {};
    }*/
    /**
     * Build a values object (result) that marks the overall pass/fail of the inspection and fills out the redundant
     * "Section E" fields.
     * @param values
     * @returns {*&{e: {typeOfInspection: *, dateOfLastInspection: *, tenantId: *, addressOfInspectedUnit: *, inspector: *}}}
     */
/*    const generatedResult = (values) => {
        const sectionE = {
            "e": {
                "tenantId": values.tenantIDNumber,
                "inspector": values.inspector,
                "dateOfInspection": values.dateOfInspection,
                "addressOfInspectedUnit": values.a.fullAddress.street1,
                "typeOfInspection": values.typeOfInspection,
            }
        };
        let result = {...values, ...sectionE};
        //DIRTY HACK. All checklist "didPass" values are embedded arrays. Flatten those arrays into a single array and
        //only mark "b.inspectionPass" as true if the resulting array contains no false values.
        result.b["inspectionPass"] = !getDidPassLeaves(values, "").flat(3).includes(false);
        return result;
    };*/
    const handleSubmit = async (values) => {
        try {
            await saveNote({content: values, attachment: null})
            history.push("/");
        } catch (error) {
            onError(error);
        }
    };

    return (
        <>
            {hqs && (HqsForm(merge(initialValues(), hqs.content), handleSubmit, DeleteButton))}
        </>
    );
}
